import parsePhoneNumberWithError from "libphonenumber-js";
export const formatPhone = (value, countryCode = 'US')=>{
    if (!value) {
        return '';
    }
    try {
        const phoneNumber = parsePhoneNumberWithError(value, {
            defaultCountry: countryCode
        });
        if (phoneNumber?.isValid()) {
            return phoneNumber.formatNational();
        }
    } catch (error) {
        console.error(error);
    }
    return value;
};

//# sourceMappingURL=formatPhone.js.map